export default __webpack_public_path__ + "static/media/roundStart.d9fd3899.mp3";